export const card_sx = {
  color: "black",
  padding: "10px",
  width: "300px",
  cursor: "pointer",
  border: "solid 1px #cacaca",
  borderRadius: "10px",
  boxShadow: "none",
  backgroundColor: "#fff",

  // '&:hover': {
  //   boxShadow:
  //     '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
  // },
};

export const grid_item_sx = {
  "@media (max-width: 480px)": {
    margin: "auto",
  },
};

export const OutlinedButtom_sx = {
  border: "solid 1px #898ea4",
  color: "black",
  borderRadius: "8px",
  padding: "8px 16px",
  // transition: "0.3s",
  "&:hover": {
    backgroundColor: "transparent",
    border: "solid 1px #898ea4",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  },
};

export const ContainedButtom_sx = {
  backgroundColor: "black",
  fontWeight: "bold",
  borderRadius: "8px",
  padding: "8px 16px",
  "&:hover": {
    backgroundColor: "#424a6d",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  },
  boxShadow: "none",
};
